import { ParamHistorical } from '../../../../../shared/types/param';

export interface Submotive4HistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    extra2: 'Descripción',
    active: 'Estado',
    parent: 'Submotivo 3',
    nestedParent: 'Submotivo 2',
    nestedParent2: 'Submotivo 1',
    nestedParent3: 'Motivo',
    nestedParent4: 'Tipo PQR',
};
